export default __webpack_public_path__ + "static/media/ursinecrush.2de927f6.png";